import { useEffect, useState } from 'react';
import { api } from '../hooks/useApi';
import { Card, Spinner, EmptyState, PageHeader, Button } from '../components/ui';
import type { CatalogItem } from '@ns-b2b/shared';

export function Catalog() {
    const [catalogs, setCatalogs] = useState<CatalogItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedCatalog, setSelectedCatalog] = useState<CatalogItem | null>(null);

    useEffect(() => { loadCatalogs(); }, []);

    const loadCatalogs = async () => {
        setIsLoading(true);
        const { data } = await api<CatalogItem[]>('/api/catalog');
        if (data) {
            const items = (data as unknown as { data: CatalogItem[] }).data || [];
            setCatalogs(items);
            if (items.length > 0) setSelectedCatalog(items[0]);
        }
        setIsLoading(false);
    };

    if (isLoading) {
        return <div className="flex justify-center py-20"><Spinner size="lg" /></div>;
    }

    return (
        <div className="space-y-6">
            <PageHeader title="แคตตาล็อก" subtitle="ดู catalog สินค้า DoHome" />

            {catalogs.length === 0 ? (
                <Card padding="lg">
                    <EmptyState icon="📚" title="ไม่มี Catalog" />
                </Card>
            ) : (
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                    {/* Sidebar */}
                    <div className="lg:col-span-1">
                        <h2 className="font-semibold text-neutral-900 mb-4">รายการ Catalog</h2>
                        <div className="space-y-2">
                            {catalogs.map((catalog) => (
                                <button
                                    key={catalog.id}
                                    onClick={() => setSelectedCatalog(catalog)}
                                    className={`w-full text-left p-4 rounded-xl transition-all
                    ${selectedCatalog?.id === catalog.id
                                            ? 'bg-primary text-white shadow-soft'
                                            : 'bg-white border border-neutral-200 hover:border-neutral-300'
                                        }`}
                                >
                                    <p className="font-medium">{catalog.name}</p>
                                    <p className={`text-sm mt-0.5 ${selectedCatalog?.id === catalog.id ? 'text-white/70' : 'text-neutral-500'
                                        }`}>
                                        {catalog.category}
                                    </p>
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Viewer */}
                    <div className="lg:col-span-3">
                        {selectedCatalog ? (
                            <Card padding="md">
                                <div className="flex items-center justify-between mb-6">
                                    <div>
                                        <h2 className="font-semibold text-neutral-900">{selectedCatalog.name}</h2>
                                        <p className="text-sm text-neutral-500">{selectedCatalog.category}</p>
                                    </div>
                                    <Button
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => window.open(selectedCatalog.url, '_blank')}
                                    >
                                        เปิดใน Tab ใหม่
                                    </Button>
                                </div>

                                <div className="aspect-[3/4] bg-neutral-50 rounded-xl flex items-center justify-center border border-neutral-200">
                                    <div className="text-center p-8">
                                        <div className="text-7xl mb-4">📄</div>
                                        <p className="text-lg font-medium text-neutral-700 mb-2">{selectedCatalog.name}</p>
                                        <p className="text-neutral-500 mb-6">คลิกปุ่มด้านบนเพื่อเปิดดู PDF</p>
                                        <Button variant="primary" onClick={() => window.open(selectedCatalog.url, '_blank')}>
                                            ดู Catalog
                                        </Button>
                                    </div>
                                </div>
                            </Card>
                        ) : (
                            <Card padding="lg">
                                <EmptyState icon="👈" title="เลือก Catalog" />
                            </Card>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
